import script from "./CheckTemplateFormTwo.vue?vue&type=script&setup=true&lang=js"
export * from "./CheckTemplateFormTwo.vue?vue&type=script&setup=true&lang=js"

import "./CheckTemplateFormTwo.vue?vue&type=style&index=0&id=0a2a9932&lang=less&scoped=true"

import exportComponent from "D:\\cwzl\\four-cw-net\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a2a9932"]])

export default __exports__